import { gql } from "@apollo/client";

export const GET_CHATS = gql`
  query getChats($channelId: ID!) {
    chats(channelId: $channelId) {
      _id
      channelId
      type
      senderId
      message
      read
      createdAt
      sender {
        _id
        firstName
        lastName
        email
      }
    }
  }
`;
